export class PayAdj {
    CompCode;
    StaffID;
    StaffName;
    JobTitle;
    EmpType;
    DateTx;
    AdjAdd;
    IncType;
    Particulars;
    Amt
    constructor() {
        {
            this.CompCode = "";
            this.StaffID = "";
            this.StaffName = "";
            this.JobTitle = "";
            this.EmpType = "";
            this.DateTx = "";
            this.AdjAdd = true;
            this.IncType = "";
            this.Particulars = "";
            this.Amt = 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/model/PayAdj.js